import { classNames } from './classNames';
import theme from './theme.scss';

export const TextAlign = {
    bind(el, binding) {
        const className = classNames('text-align', {...binding.modifiers});
        el.className += ' ' + theme[className];
    },
}



// WEBPACK FOOTER //
// ./src/baseComponents/directives/TextAlign/TextAlign.js